import { useEffect, useRef, useState } from "react";
import { Ifilter } from "../../../interfaces/IFilter";
import { IPaginacionComponent } from "../../../interfaces/base/ITable";
import { IListarLugarMovilizacionHorarioDto } from "../../../interfaces/ILugarMovilizacionHorario";
import { _initialFilter } from "../../../utils/Helper/helper";
import { LugarMovilizacionService } from "../../../services/movilizacion/LugarMovilizacionService";
import { IResponseApiFluent } from "../../../interfaces/base/IResponse";

const useListaLugaresMovilizacionHorarios = (
  idEliminar?: string,
  closePanelEliminar: () => void = () => {}
) => {
  const [loadingTabla, setLoadingTabla] = useState<boolean>(false);
  const [items, setItems] = useState<IListarLugarMovilizacionHorarioDto[]>([]);
  const [filter, setFilter] = useState<Ifilter>(_initialFilter);
  const [status, setStatus] = useState<number | null>(null);
  const [mensaje, setMensaje] = useState<string>("");

  const [loadingDelete, setLoadingDelete] = useState<boolean>(false);

  const controllerRef = useRef<AbortController>(new AbortController())

  const onChangeTake = (take: number) => {
    setFilter({ ...filter, take: take, skip: 0 });
  };
  const onSkip = (skip: number) => {
    setFilter({ ...filter, skip: skip });
  };

  const [pagination, setPagination] = useState<IPaginacionComponent>({
    isLoading: loadingTabla,
    onChangeTake: onChangeTake,
    onChangeSkip: onSkip,
    totalPagesPagination: 10,
    skipPagination: filter.skip,
    takePagination: filter.take ?? 0,
    isVisible: true,
    total: 0,
  });

  const handleResetUpdate = () => {
    setFilter(_initialFilter);
  };

  const listarLugaresMovilizacionHorarios = () => {
    setLoadingTabla(true);

    controllerRef.current.abort()
    const newController = new AbortController()
    controllerRef.current = newController;

    LugarMovilizacionService.ListarLugaresMovilizacionHorarios(filter, newController)
      .then((res) => {
        setPagination({
          isLoading: loadingTabla,
          onChangeTake: onChangeTake,
          onChangeSkip: onSkip,
          totalPagesPagination: res.data.pages,
          skipPagination: filter.skip,
          takePagination: filter.take ?? 0,
          isVisible: true,
          actualPage: res.data.page,
          total: res.data.total,
        });
        setItems(res.data.items);

        closePanelEliminar();
      })
      .catch((e: any) => {
        console.log(e);
      })
      .finally(() => {
        setLoadingTabla(false);
      });
  };

  const deleteEliminarLugarMovilizacionHorario = () => {
    setLoadingDelete(true);

    LugarMovilizacionService.EliminarLugarMovilizacionHorario({
      lugarMovilizacionHorarioId: idEliminar ?? "",
    })
      .then((res) => {
        if (res.status == 200) {
          setStatus(200);
          setMensaje(res.data.mensaje);
          setTimeout(() => {
            handleResetUpdate();
            closePanelEliminar();
            setStatus(null);
            setMensaje("");
          }, 3000);
        } else {
          setStatus(500);
        }
      })
      .catch((e) => {
        if (
          e.response?.data &&
          "type" in e.response.data &&
          "title" in e.response.data &&
          "status" in e.response.data &&
          "instance" in e.response.data &&
          "errors" in e.response.data
        ) {
          const errorResponse = e.response.data as IResponseApiFluent;
          const mensajeError = errorResponse.errors.join("\n");
          setMensaje(mensajeError);
        } else {
          setMensaje("Error Inesperado");
        }
        setStatus(500);
      })
      .finally(() => {
        setLoadingDelete(false);
      });
  };

  const onChangeSearch = (
    event?: React.ChangeEvent<HTMLInputElement> | undefined,
    newValue?: string | undefined
  ) => {
    setFilter({ ...filter, skip: 0, search: newValue });
  };

  useEffect(() => {
    if (filter) {
      listarLugaresMovilizacionHorarios();
    }
  }, [filter]);

  return {
    items,
    filter,
    setFilter,
    loadingTabla,
    pagination,
    handleResetUpdate,
    onChangeSearch,
    deleteEliminarLugarMovilizacionHorario,
    loadingDelete,
    status,
    mensaje,
  };
};

export { useListaLugaresMovilizacionHorarios };
